export const COPYRIGHT_CONTACT_US_LINK =
  "https://share.hsforms.com/1CK8Y0vv-TuOeBbDac-CMTgbvumd";

export const COPYRIGHT_SUPPORT_LINK =
  "https://support.thenational.academy/what-is-copyright-and-signing-in";
